import { commitmentTranslations } from "./commitment";

export const translations = {
  en: {
    comuTitle: "Catholic Community El Salvador Del Mundo",
    mainPhrase: "United in faith and service to our community.",
    copyright: "Catholic Community El Salvador Del Mundo. All rights reserved.",
    close: "Close",
    appTitle: "Bible Study",
    loginWelcomeMessage: "Welcome",
    loginPasswordPlaceholder: "Password",
    loginUserPlaceholder: "Username",
    loginButtonText: "Submit",
    loginBiblicalQuote: `The Lord said to me, “Speak a prophetic message to these bones and say, ‘Dry bones, listen to the word of the Lord! This is what the Sovereign
Lord says: Look! I am going to put breath into you and make you live again! I will put flesh and muscles on you and cover you with skin. I will put breath into you, and you will come to life. Then you will know that I am the Lord.`,
    loginBiblicalQuoteReference: "Ezekiel 37:4",
    loginUserNameRequired: "Username is required",
    loginPasswordRequired: "Password is required",
    loginGenericError: "An error occurred. Please try again later.",
    forgotPassword: "Forgot password?",
    forgotPasswordTitle: "Reset your password",
    forgotPasswordDescription: "Enter your email and we'll send you a link to reset your password.",
    forgotPasswordEmailPlaceholder: "your@email.com",
    forgotPasswordSuccess: "Check your inbox! If that email is registered, you'll receive a reset link shortly.",
    forgotPasswordError: "Something went wrong. Please try again.",
    resetPasswordTitle: "Create a new password",
    resetPasswordDescription: "Enter your new password below.",
    resetPasswordButton: "Save password",
    resetPasswordSuccess: "Your password has been updated. You can now log in with your new password.",
    resetPasswordInvalidLink: "This reset link is invalid or has expired. Please request a new one.",
    resetPasswordMinLength: "Password must be at least 6 characters",
    goToLogin: "Go to login",
    send: "Send",
    contact: "Contact",
    genericErrorTitle: "An error occurred",
    mainMenuHome: "Home",
    mainMenuEvents: "Events",
    mainMenuServices: "Meetings",
    mainMenuSecurity: "Security",
    mainMenuInvitations: "Invitations",
    mainMenuCommitments: "Commitment",
    mainMenuPrayerRequests: "Prayer Requests",
    mainMenuPreaching: "Preaching",
    eventFilterTitle: "Main Filters",
    eventFilterGroupPlaceholder: "Groups",
    eventFilterPlaceholder: "Events",
    logout: "Logout",
    myProfile: "My Profile",
    profilePersonalInfo: "Personal Information",
    profileFullName: "Full Name",
    profileEmail: "Email Address",
    profilePhone: "Phone",
    profileBirthDate: "Date of Birth",
    profileLocation: "Location",
    profileSecurity: "Security",
    profileChangePassword: "Change Password",
    profileTwoFactor: "Two-Factor Authentication",
    profileUploadPhoto: "Upload photo",
    profileRoleAdmin: "Administrator",
    profileRoleUser: "Member",
    profileTwoFactorDisabled: "Disabled",
    profileTwoFactorEnabled: "Enabled",
    profilePreferences: "Preferences",
    profileNotifications: "Notifications",
    profileLanguage: "Language",
    profileCurrentPassword: "Current password",
    profileNewPassword: "New password",
    profileConfirmPassword: "Confirm new password",
    profilePasswordChanged: "Password changed!",
    profilePasswordChangedDesc: "Your password has been updated successfully.",
    profileWrongPassword: "The current password is incorrect. Please try again.",
    profileChangePasswordError: "An error occurred. Please try again later.",
    profilePasswordMinLength: "Password must be at least 8 characters",
    profilePasswordsNoMatch: "Passwords do not match",
    eventMenuInscription: "Inscription",
    eventMenuIncome: "Income",
    eventMenuRooms: "Rooms",
    eventMenuComissions: "Comissions",
    eventMenuWorkshops: "Workshops",
    eventMenuDashboard: "Dashboard",
    eventMenuSummaryByGroup: "Summary by Group",
    eventMenuServers: "Servers",
    eventMenuAttendance: "Attendance",
    eventMenuDashboardTitle: "Event Summary",
    attendanceIndicatorTitle: "Attendance count",
    noAccessText: "You don't have access to this section",
    eventMenuPrint: "Print",
    eventMenuConfig: "Configurations",
    eventMenuFilters: "Filters",
    eventMenuRefresh: "Refresh",
    eventMenuMoveParticipants: "Move participants",
    moveParticipantsTitle: "Move participants",
    moveParticipantsSelectParticipants: "Select participants to move",
    moveParticipantsSelectEvent: "Select destination event",
    moveParticipantsConfirm: "Move",
    moveParticipantsSuccess: "Participants moved successfully",
    moveParticipantsNoneSelected: "Select at least one participant",
    moveParticipantsAlreadyExists: "already exists in this event",
    searchParticipant: "Search participant...",
    selectAll: "Select all",
    deselectAll: "Deselect all",
    next: "Next",
    back: "Back",
    genericError: "An error occurred",
    eventMenuCalls: "Calls",
    guestGridSearchPlaceholder: "Search...",
    guestGridColPhone: "Phone",
    guestGridColName: "Name",
    guestGridColLastName: "Last Name",
    guestGridColAge: "Age",
    guestGridColGender: "Gender",
    guestGridColGroup: "Group",
    guestGridColMaritalStatus: "Marital Status",
    guestGridColSpecialFood: "Esp Food",
    guestGridColHasIllnes: "Has Illness",
    guestGridColExtraFood: "Extra Food",
    guestGridColExtraStay: "Extra Stay",
    guestGridColConvertionDate: "Convertion Date",
    guestGridColStatus: "Status",
    guestGridColPaymentStatus: "Payment Status",
    guestGridColCalls: "Calls",
    guestGridColVechicle: "Vechicle",
    guestGridColWhoRecommended: "Who Recommended",
    guestGridFiltersTitle: "Filters",
    guestGridFilterGuests: "Guests",
    guestGridFilterMovements: "Movements",
    guestGridFilterServers: "Servers",
    guestGridFilterAll: "All",
    guestGridFilterConfirmed: "Confirmed",
    guestGridFilterInvited: "Invited",
    guestGridFilterRegistered: "Registered",
    guestGridFilterPending: "Pending",
    guestGridFilterNext: "Next",
    guestGridFilterDeclined: "Declined",
    guestGridFilterPaymentComplete: "Completed",
    guestGridFilterPaymentPending: "Pending",
    guestGridFilterPaymentPartial: "Partial",
    guestGridFilterEspetialFood: "Special Food",
    guestGridFilterIllness: "Illness",
    guestGridFilterMale: "Male",
    guestGridFilterFemale: "Female",
    guestGridFilterBringingVehicle: "Bringing Vehicle",
    guestGridFilterNoAttendance: "No Attendance",
    guestGridFilterItAttendance: "Attendance",
    attendancePendingTitle: "Pending Attendance",
    guestGridFilterExtraStay: "Extra Stay",
    guestGridFilterExtraFood: "Extra Food",
    guestGridFilterType: "Type",
    guestGridFilterStatus: "Confirmation Status",
    guestGridFilterPayment: "Payment Status",
    options: "Options",
    guestGridFilterIssues: "Search by Issues",
    guestGridFilterGender: "Gender",
    guestGridFilterAttendance: "Attendance",
    guestGridFilterOther: "Other",
    attendanceTitle: "Attendance",
    attendanceNotToday: "Attendance can only be marked on retreat days ({date}).",
    meetingServiceStartTime: "Start Time",
    meetingServiceEndTime: "End Time",
    startTime: "Start Time",
    endTime: "End Time",
    selectMeeting: "Select a meeting",
    changeMeeting: "Change meeting",
    noTitle: "No title",
    selectDate: "Select date",
    currentMeeting: "Current meeting",
    searchMeeting: "Search meeting",
    current: "Current",
    noScheduledDates: "No scheduled dates",
    newMeeting: "New meeting",
    createAndSchedule: "Create and schedule",
    meetingDate: "Meeting date",
    dateAssociatedWithSelectedMeeting: "Date associated with the selected meeting",
    changesWillReflectInAttendanceList: "Changes will reflect in the attendance list",
    availableServers: "Available Servers",
    noAssignedServers: "No servers assigned yet",
    assignedServers: "Assigned Servers",
    assign: "Assign",
    total: "Total",
    male: "Male",
    female: "Femenino",
    married: "Married",
    single: "Single",
    divorced: "Divorced",
    widowed: "Widowed",
    accompaned: "Accompanied",
    yes: "Yes",
    no: "No",
    confirmed: "Confirmed",
    verified: "Verified",
    invited: "Invited",
    callPending: "Call Pending",
    nextTime: "Next Time",
    pendingPayment: "Pending",
    paymentComplete: "Complete",
    paymentPartial: "Partial",
    brand: "Brand",
    plate: "Plate",
    transfer: "Transfer",
    cash: "Cash",
    check: "Check",
    other: "Other",
    edit: "Edit",
    call: "Call",
    date: "Date",
    eventDoneMessage: "The event was done on {date}",
    addInvitation: "Create Invitation",
    servicesTabTitle: "Services",
    addServer: "Add Server",
    editServer: "Edit Server",
    attendanceGridColName: "Name",
    attendanceGridColAge: "Age",
    attendanceGridColLastName: "Last Name",
    attendanceGridColPhone: "Phone",
    attendanceGridColRoom: "Room",
    attendanceGridColHouse: "House",
    attendanceGridColWorkshop: "Workshop",
    attendanceGridColAttendance: "Attendance",
    attendanceGridColPayment: "Payment",
    attendanceGridColViewProfile: "View Profile",
    assignWorkshopsByAge: "Assign Workshops by Age",
    assignWorkshopsRandomly: "Assign Workshops Randomly",
    all: "All",
    groups: "Groups",
    of: "of",
    paymentsList: "Payments List",
    rooms: "Rooms",
    roomsNoEditAccess: "You don't have permissions to edit rooms",
    currentTotalServers: "Current Total Servers",
    groupByAgeBarChartTitle: "Group by Age",
    groupByMaritalStatusBarChartTitle: "Group by Marital Status",
    groupByMinistryBarChartTitle: "Group by Ministry",
    groupByConvertionYearsBarChartTitle: "Group by Convertion Years",
    nextRetreats: "Next Retreats",
    available: "Available",
    notAvailable: "Not Available",
    priests: "Priests",
    firstFloor: "1st Floor",
    secondFloor: "2nd Floor",
    marysHouse: "Mary's House",
    searchRoomsPlaceholder: "Search by room number...",
    noConnection: "No internet connection",
    confirmUpdateWorkshopsByAge: "Are you sure you want to update the workshops by age?",
    configWorkshopsCount: "Configure workshops count",
    uploadPayment: "Upload Payment",
    paymentsHistory: "Payments History",
    accept: "Accept",
    availableBeds: "Available Beds",
    dashboard: "Dashboard",
    assignedServices: "Services",
    assignServices: "Assign Services",
    assignServicesCaption: "Assign servers to services for upcoming meetings",
    selectMeetingHelperText: "Please select a meeting to start assigning services",
    serversManagement: "Servers Management",
    serversManagementCaption: "Manage servers and their service skills",
    noMeetingSelected: "No meeting selected",
    servicesManagement: "Services Management",
    generatingReport: "Generating Report",
    servicesManagementCaption: "Manage the different services needed for meetings",
    services: "Services",
    upcommingMeetings: "Upcoming meetings",
    upcommingMeetingsCaption: "View and manage upcoming meetings",
    calendar: "Calendar",
    calendarCaptioon: "Select a date to view meetings",
    serviceStats: "Service Stats",
    serviceStatsCaption: "Overview of service assignments",
    quickActions: "Quick Actions",
    quickActionsCaption: "Common tasks and actions",
    filterByCallName: "Filter by caller",
    filteredByCallerName: "Filtered by caller: {callerName}",
    allCallers: "All callers",
    paymentNotes: "Payment Notes",
    paymentNotesPlaceholder: "Add payment notes",
    history: "History",
    noRecordsFound: "No records found",
    results: "results",
    selectEventPlaceholder: "Select an event",
    groupHasNoEvents: "Group has no events available",
    createNewEvent: "Create new event",
    openFilters: "Open Filters",
    filtersApplied: "Filters Applied",
    paymentGeneralDetails: "General Payment Details",
    noPayments: "No payments",
    refund: "Refund",
    noResults: "No results found",
    noNextRetreats: "No next retreats available",
    attendanceGridColSpecialFood: "Special Food",
    service: "Service",
    lastServer: "Last Server",
    noMeetingDataAvailable: "No meeting data available",
    removeMeetingService: "Remove Meeting Service",
    meetingAttendance: "Attendance",
    meetingAttendanceCaption: "Mark attendance for servers at each meeting",
    markAttendance: "Mark attendance",
    noMeetingAttendanceData: "No attendance data for this meeting",
    attended: "Attended",
    notAttended: "Did not attend",
    replaceServer: "Replace Server",
    attendedCount: "{count} attended",
    justifiedCount: "{count} justified",
    attendedSuffix: " (Attended) ✅",
    referenceMeetingForAttendance: "Check attendance from:",
    eventWorkshopsAddWorkshop: "Add Workshop",
    autoAssignRooms: "Auto Assign Rooms",
    registersFound: "records found",
    changeStatus: "Change Status",
    guestProfile: "Profile",
    guestPayments: "Payments",
    guestCallList: "Call List",
    guestCarInfo: "Car Info",
    updateInfoText: "Update Info",
    guestAdminTools: "Admin Tools",
    eventForm: {
      formType: {
        tob: "TOB Retreat",
        initial: "Conversion Retreat",
        initialForeign: "Initial Conversion Retreat Abroad",
        marriage: "Marriage Retreat"
      },
      genderType: {
        male: "Males",
        female: "Females",
        both: "Both"
      }
    },
    attendanceMaleLength: "{count} Males",
    attendanceFemaleLength: "{count} Females",
    attendanceByGender: "Attendance by Gender",
    // Generic
    cancel: "Cancel",
    save: "Save",
    add: "Add",
    delete: "Delete",
    pending: "Pending",
    loading: "Loading...",
    uploadImage: "Upload image",
    reload: "Reload",
    oops: "Oops!",
    active: "Active",
    inactive: "Inactive",
    saving: "Saving...",
    sending: "Sending...",
    deleting: "Deleting...",
    view: "View",
    hide: "Hide",
    commentsLabel: "Comments",
    nameRequired: "Name is required",
    descriptionLabel: "Description",
    descriptionRequired: "Description is required",
    meetingSchedule: "Meeting schedule",
    dangerZone: "Danger zone",
    actionCannotBeUndone: "This action cannot be undone",
    errorOccurredWith: "An error occurred: {error}",
    // Days of week
    sunday: "Sunday",
    monday: "Monday",
    tuesday: "Tuesday",
    wednesday: "Wednesday",
    thursday: "Thursday",
    friday: "Friday",
    saturday: "Saturday",
    // Status badges
    statusInvited: "Invited",
    statusConfirmed: "Confirmed",
    statusDeclined: "Declined",
    statusNextTime: "Next",
    statusCallPending: "Call Pending",
    // Payment status badges
    paymentPartialBadge: "Partial Payment",
    paymentPaidBadge: "Paid",
    paymentOverpaidBadge: "Participant has overpaid",
    paymentPendingBadge: "Pending Payment",
    // Auth module
    filterByGroup: "Filter by group",
    allGroups: "All groups",
    emailLabel: "Email",
    nameLabel: "Name",
    passwordLabel: "Password",
    generatePassword: "Generate Password",
    enabled: "Enabled",
    adminLabel: "Admin",
    selectRole: "Select a role",
    selectGroupOption: "Select a group",
    selectEvent: "Select an event",
    newUser: "New User",
    errorCreatingUser: "Error creating user",
    allFieldsRequired: "All fields are required",
    systemUsers: "System users",
    searchUser: "Search user",
    newUserButton: "New user",
    usernameColumn: "Username",
    changePassword: "Change password",
    newPassword: "New password",
    // Security admin tabs
    securityTabUsers: "Users",
    securityTabRoles: "Roles",
    securityTabGroups: "Groups",
    searchRole: "Search role...",
    usersWithRole: "Users with this role",
    roleModule_groups: "Groups & guests",
    roleModule_workshopsRooms: "Workshops & rooms",
    roleModule_payments: "Payments",
    roleModule_events: "Events",
    roleModule_invitations: "Invitations",
    roleModule_services: "Services & meetings",
    roleModule_commitments: "Commitments",
    roleModule_prayerRequests: "Prayer requests",
    roleModule_preaching: "Preaching",
    roleModule_administration: "Administration",
    roleModule_other: "Other",
    noGroupsAvailable: "No groups available",
    usersInGroup: "Users in this group",
    searchGroup: "Search group...",
    noUsersFound: "No users found",
    usersCount: "{count} users",
    // Groups module
    addGroup: "Add group",
    groupConfig: "Group configuration",
    newGroup: "New Group",
    codeLabel: "Code",
    groupCodeLabel: "Code",
    groupCodePlaceholder: "Code (used for the url)",
    saveChanges: "Save Changes",
    createGroup: "Create Group",
    columnCommission: "Commission",
    columnCreatedAt: "Created",
    // Invitations module
    signMeUp: "Sign me up",
    selectServer: "Select a server",
    inscriptionSuccess: "Successful inscription!",
    guestList: "Guest list",
    openLink: "Open link",
    invitationTitleLabel: "Title",
    invitationStartDate: "Start date",
    invitationLocation: "Location",
    invitationTitleRequired: "Title is required",
    invitationCodeRequired: "Code is required",
    invitationStartDateRequired: "Start date is required",
    invitationStatusRequired: "Status is required",
    invitationDisplaySettings: "Display settings",
    invitationShowServerList: "Show server list",
    invitationHideCustomFields: "Hide inscription form",
    invitationHideDetails: "Hide event details",
    invitationCustomFieldsTitle: "Inscription form fields",
    invitationAddCustomField: "Add field",
    invitationNoCustomFields: "No fields have been added yet",
    invitationCustomFieldLabel: "Label",
    invitationCustomFieldName: "Key",
    invitationCustomFieldType: "Type",
    invitationCustomFieldRequired: "Required",
    invitationFieldTypeText: "Text",
    invitationFieldTypeEmail: "Email",
    invitationFieldTypePhone: "Phone",
    invitationFieldTypeCheckbox: "Checkbox",
    invitationFieldLabelRequired: "The label is required",
    invitationFieldNameRequired: "The key is required",
    invitationFieldNameDuplicated: "Field keys cannot be repeated",
    addGuestButton: "Add guest",
    meetingServiceFormServiceName: "Add service to meeting",
    meetingServiceFormDescription: "Description",
    meetingServiceFormDate: "Service Date",
    meetingServiceFormTitle: "Meeting Title",
    meetingServiceFormTitlePlaceholder: "Meeting Title",
    addGuestPlaceholder: "Add Guest",
    // Prayer requests module
    prayerRequestEntries: "Entries",
    prayerRequestText: "Request",
    prayerRequestCount: "prayer requests",
    exportXLS: "Export XLS",
    exportPDF: "Export PDF",
    noEntries: "No entries registered",
    editPrayerRequest: "Edit Prayer Request",
    newPrayerRequest: "New Prayer Request",
    prayerRequestCodeLabel: "Code (Public Route)",
    prayerRequestAvatarUrl: "Avatar URL (optional)",
    prayerRequestBannerUrl: "Banner URL (optional)",
    prayerRequestStatusLabel: "Status",
    confirmDeletePrayerRequest: "Are you sure you want to delete this prayer request?",
    prayerRequestModule: "Prayer Requests Module",
    noPrayerRequests: "No prayer requests configured.",
    prayerRequestNotFound: "Prayer request not found",
    prayerRequestInvalidLink: "This link is no longer valid or has been deactivated.",
    prayerRequestSent: "Request sent!",
    prayerRequestSentMessage: "Thank you for sharing your request. We will be praying for you.",
    sendAnotherRequest: "Send another request",
    writeYourRequest: "Write your request",
    writeYourRequestPlaceholder: "Write your request here. It is completely anonymous.",
    sendRequest: "Send request",
    // Payment form
    fileRequired: "You must select a file",
    amountRequired: "Amount must be greater than 0",
    paymentSentSuccess: "Payment receipt sent successfully",
    paymentTypeLabel: "Payment type",
    movementTypeLabel: "Movement type",
    creditOption: "Credit",
    refundOption: "Refund",
    amountLabel: "Amount",
    amountAutoFill: "The amount will be auto-filled if a receipt is uploaded",
    totalPaidNegativeError: "The total amount paid cannot be less than 0",
    analyzingReceipt: "Analyzing receipt...",
    receiptAmount: "Receipt amount",
    uploadReceipt: "Upload receipt",
    multiplePaymentQuestion: "Does the payment apply to multiple participants?",
    selectParticipantsForPayment: "Select participants to apply payment to",
    paymentCommentsLabel: "Comments",
    paymentCommentsPlaceholder: "Payment comments",
    sendAnotherReceipt: "Send another receipt",
    errorSendingReceipt: "Error sending receipt",
    errorAnalyzingReceipt: "The receipt could not be analyzed, enter the amount manually",
    amountNotFoundOnReceipt: "The amount could not be read from the receipt, enter it manually",
    // Guest module
    vehicleInfo: "Vehicle information",
    saveVehicleInfo: "Save vehicle information",
    callHistory: "Call history",
    notSpecified: "Not specified",
    noCallsRegistered: "No calls have been registered",
    newCall: "New call",
    deleteParticipant: "Delete participant",
    deleteServer: "Delete server",
    assignedServer: "Assigned server",
    callerNameLabel: "Server name",
    dateRequired: "Date is required",
    serverNameRequired: "Server name is required",
    // Preaching module
    preachingEventsTab: "Sermons",
    preachingSermonsTab: "Sermons",
    preachingMeetingsTab: "Meetings",
    preachingPreferencesTab: "Preferences",
    preachingMyPreachingsTab: "My preachings",
    preachingUpcomingEvents: "Upcoming Events",
    preachingUpcomingEventsCaption: "Next scheduled preaching events",
    preachingRecentSermons: "Recent Sermons",
    preachingRecentSermonsCaption: "Latest sermons added",
    preachingNextMeeting: "Next Planning Meeting",
    preachingNextMeetingCaption: "Upcoming planning meeting details",
    preachingPeriod: "Period",
    preachingNewEvent: "New Event",
    preachingNewSermon: "New Sermon",
    preachingNewMeeting: "New Meeting",
    preachingNewPreference: "New Preference",
    preachingGenerateAssignments: "Generate Assignments",
    preachingScheduleTab: "Scheduling",
    preachingUpcomingOnly: "Upcoming only",
    preachingSelectMeeting: "Select a meeting to see its detail",
    preachingNoEventsInPeriod: "No preachings in this period",
    preachingGenerateConfirmation:
      "Are you sure you want to generate automatic assignments? This will assign preachers to events based on configured rules.",
    preachingAssignedCount: "{count} assignments generated",
    preachingUnassignedSlots: "{count} slots could not be assigned",
    preachingPreacher: "Preacher",
    preachingGroup: "Group",
    preachingStatus: "Status",
    preachingRating: "Rating",
    preachingEventDetails: "Event Details",
    preachingSermonDetails: "Sermon Details",
    preachingSermonTitle: "Title",
    preachingMeetingDetails: "Meeting Details",
    preachingMeetingDate: "Meeting Date",
    preachingPlanningStart: "Planning Start",
    preachingPlanningEnd: "Planning End",
    preachingPreferenceDetails: "Preference Details",
    preachingAllowedZones: "Allowed Zones",
    preachingAllZones: "All zones (no restriction)",
    preachingZonesHelp: "Leave empty to allow all zones",
    preachingNoPreferences: "No preferences configured",
    preachingPreacherActive: "Active preacher",
    preachingZonesRequired: "Select at least one zone to save",
    preachingMissingPreacherHint:
      "Don't see a preacher? They must be registered in the current commitment with the Preaching ministry. Each preacher can set their zones from their own profile.",
    preachingNoAttendanceRecords: "No attendance records",
    preachingAttendance: "Attendance",
    preachingSaveAttendance: "Save Attendance",
    preachingAttendanceSaveFailed: "Could not save. Try again.",
    preachingStatusDraft: "Draft",
    preachingStatusPublished: "Published",
    preachingStatusArchived: "Archived",
    preachingStatusScheduled: "Scheduled",
    preachingStatusInProgress: "In Progress",
    preachingStatusCompleted: "Completed",
    preachingStatusCancelled: "Cancelled",
    preachersAvailable: "Available Preachers",
    preachersAvailableDesc:
      "List of commitment servers associated with PREDICA ministry. Edit their status and comments below.",
    inTraining: "In Training",
    preachersTotalPreachings: "Preachings",
    preachersGroupsServed: "Groups",
    preachersLastPreaching: "Last preaching",
    preachersAvgAttendance: "Avg. attendance",
    preachersHistory: "Preaching History",
    preachersSelectToView: "Select a preacher to view their history",
    preachersNoHistory: "No preachings found for this preacher",
    preachersStatusLabel: "Preacher status",
    preachersAllStatuses: "All statuses",
    addComment: "Add a comment...",
    search: "Search...",
    zones: {
      title: "Zones",
      central: "Central",
      paracentral: "Paracentral",
      oriental: "Oriental",
      occidental_santa_ana: "Occidental - Santa Ana",
      occidental_sonsonate: "Occidental - Sonsonate"
    },
    otherGroupConfigs: "Other group configurations",
    isVirtual: "Is virtual",
    isVisible: "Is visible (public appearance)",
    isWithMeeting: "Is with meeting",
    signinServerTitle: "Sign in as server",
    signinServerDescription:
      "Sign in with the email you provided in the commitment inscription to access your server profile and manage your assigned services.",
    loginConfirmPasswordPlaceholder: "Confirm password",
    signinServerButtonAction: "Sign in from commitment server",
    signinSuccess: "Sign in successful! Redirecting to your profile...",
    signinFailed: "Error signing in",
    passwordsDoNotMatch: "Passwords do not match",
    userHelloByTime: "{timeOfDay}, {name}!",
    preachingPageLabel: "Your preaching schedule and assignments",
    myPreachings: "My preachings",
    preachingNextAssignment: "Your next preaching",
    preachingNoAssignmentsNoMeeting: "The planning meeting for this period has not been created yet.",
    preachingNoAssignmentsDidNotAttend: "You did not attend the planning meeting and do not have an approved absence.",
    preachingNoAssignmentsNotGeneratedYet:
      "You are eligible for an assignment, but the distribution has not been generated yet.",
    preachingConfirmAssignment: "Confirm preaching",
    preachingSearchPreachers: "Search preachers by name or phone...",
    morning: "Morning",
    afternoon: "Afternoon",
    evening: "Evening",
    morningPrefix: "Good morning",
    afternoonPrefix: "Good afternoon",
    eveningPrefix: "Good evening",
    nextPreachings: "Next preaching events",
    noNextPreachings: "No upcoming preaching events available",
    preachingNoZonePreference:
      "No zone preference, select your preferred zones to be assigned to those zones, you will able to update this later in your preferences",
    zonesMode: "Zones mode",
    groupsMode: "Groups mode",
    selectedZonesCount: "{count} zones selected",
    dateExceptionsRangeHelp: "Add date ranges where you won't be available to preach.",
    startDate: "Start",
    endDate: "End",
    preachingFrequencyQuestion: "How many times are you willing to preach in a two-month period?",
    frequencyNoPreference: "No preference (as many as God sends me)",
    frequencyNone: "None",
    frequencyOnlyOne: "Only 1",
    editPreferences: "Edit preferences",
    scriptureReference: "Scripture reference",
    scriptureReferencePlaceholder: "E.g. John 3:16",
    liaisonView: "Liaison View",
    liaisonViewDesc: "Manage the preaching events of your group",
    noGroupsAssigned: "You don't have any groups assigned",
    noGroupsAssignedPermission:
      "You do not have groups assigned. Ask a security administrator to assign your groups from the Security module.",
    newPlannedAssignment: "New planned assignment",
    preacherAlreadyAssigned: "already has a preaching assigned on this date.",
    chooseAnotherPreacher: "Choose a different preacher to continue.",
    preacherAlreadyAssignedError: "This preacher already has a preaching assigned on this date",
    preacherUnavailableTitle: "Preacher unavailable",
    preacherDateExceptionError: "This preacher marked this date as unavailable.",
    upcomingEvents: "Upcoming events",
    assignToFirstFloor: "Assign to first floor",
    sortOrder: "Preacher order",
    sortAlphabetical: "Alphabetically",
    sortRandom: "Random",
    preachingZones: "Preferred zones",
    dateExceptions: "Unavailable dates",
    assemblyDay: "Assembly day",
    selectOption: "Select...",
    daySunday: "Sunday",
    dayMonday: "Monday",
    dayTuesday: "Tuesday",
    dayWednesday: "Wednesday",
    dayThursday: "Thursday",
    dayFriday: "Friday",
    daySaturday: "Saturday",
    editEventDetails: "Preaching details",
    preachingTitlePlaceholder: "Preaching name",
    preachingStatusPending: "Pending",
    preachingStatusConfirmed: "Confirmed",
    preachingStatusRejected: "Rejected",
    preachingStatusAssignedByLeader: "Assigned by Leader",
    assignedByLeader: "Assigned by Leader",
    dropImageHere: "Drag the image here or click to select",
    myCalendar: "My Calendar",
    calendarToday: "Today",
    calendarWeekView: "Week",
    calendarMonthView: "Month",
    calendarMeeting: "Meeting",
    calendarNoEventsWeek: "No events this week",
    noServices: "No services",
    disposition: "Bimonthly availability",
    previousPreachings: "Previous preachings",
    loginPageLabel: "Access your preaching schedule and preferences",
    preachingNoZones: "No zones assigned",
    preachingDashboardTab: "Dashboard",
    preachingDashboardTotalPreachers: "Total Preachers",
    preachingDashboardTotalPreachersDesc: "Active in period",
    preachingDashboardTotalDates: "Total Dates",
    preachingDashboardTotalDatesDesc: "In selected range",
    preachingDashboardTotalGroups: "Groups",
    preachingDashboardTotalGroupsDesc: "With assigned preachings",
    preachingDashboardTotalAttendance: "Total Attendance",
    preachingDashboardTotalAttendanceDesc: "In selected range",
    preachingDashboardAvgAttendance: "Avg. Attendance",
    preachingDashboardAvgAttendanceDesc: "Across all preachings",
    preachingDashboardByGroupDate: "Preachers per Group / Date",
    preachingDashboardByPreacher: "Group / Date per Preacher",
    preachingDashboardUpcoming: "Upcoming Preachings",
    preachingDashboardAttendanceTrend: "Attendance Trend",
    preachingDashboardAttendanceIndicators: "Attendance Indicators",
    preachingDashboardExcellent: "Excellent",
    preachingDashboardGood: "Good",
    preachingDashboardAverage: "Average",
    preachingDashboardLow: "Low",
    preachingDashboardPreachings: "preachings",
    preachingDashboardViewAll: "View all assignments",
    preachingDashboardViewAllPreachers: "View all preachers",
    preachingDashboardViewFullSchedule: "View full schedule",
    preachingAssignmentsConsole: "Assignments console",
    preachingAssignmentsConsoleDesc: "Consult all preaching assignments for the current period.",
    preachingAssignmentsByGroup: "By group",
    preachingAssignmentsByPreacher: "By preacher",
    preachingAssignmentsDates: "{count} dates",
    preachingAssignmentsGroups: "{count} groups",
    preachingAssignmentsLocal: "{count} local",
    preachingAssignmentsOutsideZone: "{count} outside zone",
    preachingAssignmentsUnknownZone: "{count} without defined zone",
    preachingAssignmentsNoMeeting:
      "There is no planning meeting for the current period. Create the planning meeting to view assignments.",
    preachingAssignmentsNoEvents:
      "The current period has a planning meeting but no preaching assignments yet. Create the preaching meeting assignments to view them here.",
    preachingNotifyPreachers: "Notify preachers",
    preachingResendNotification: "Resend notification",
    preachingNotifyNoMeeting: "There is no planning meeting for the current period.",
    preachingNotifyNoAssignments: "There are no preaching assignments for the current period.",
    preachingNotificationsSent: "{count} preachers notified.",
    preachingNotificationsSkipped: "{count} skipped because they do not have an email address.",
    preachingDashboardNoData: "No data in the selected period",
    preachingDashboardFilterPeriod: "Period",
    preachingDashboardAssign: "Assign Preaching",
    preachingDashboardOfMax: "of max",
    preachingAttendanceCount: "Attendance count",
    preachingEventsFilterGroup: "All groups",
    preachingEventsFilterPreacher: "All preachers",
    preachingEventsFilterStatus: "All statuses",
    preachingEventsFilterFrom: "From",
    preachingEventsFilterTo: "To",
    preachingEventsFilterReset: "Reset filters",
    preachingEventsAttendance: "Attendance",
    preachingEventsPageOf: "of",
    preachingEventsRowsPerPage: "per page",
    preachingEventsConfirmDelete: "Delete preaching?",
    preachingEventsConfirmDeleteMessage: "This action cannot be undone.",
    preachingEventsNoResults: "No events match the current filters.",
    homeLabelMessage:
      "Welcome to the management platform of the Catholic Community El Salvador del Mundo: manage retreats, services, and your preaching schedule in one place.",
    seeAll: "See all",
    login: "Login",
    seeCalendar: "See calendar",
    notAttendedBadge: "Did not attend",
    attendedBadge: "Attended",
    absentPermission: "Permission to be absent",
    absenceReason: "Absence reason",
    absentPermissionOf: "of",
    attendedNoCount: "{count} not attended",
    // Nickname
    nickname: "Nickname",
    nicknamePlaceholder: "How we call them",
    // Duplicate server alert
    serverAlreadyAssigned: "Already assigned to another service",
    confirmAssignDuplicate: "This server is already assigned to another service. Assign anyway?",
    // Gender filter modal
    selectServerForService: "Select server",
    filters: "Filters",
    clear: "Clear",
    apply: "Apply",
    attendedOnlyTooltip: "Filter to only show servers who attended this meeting",
    filterAttended: "Attended only",
    filterNotAttended: "Not attended only",
    notAttendedOnlyTooltip: "Filter to only show servers who did not attend this meeting",
    filterAvailables: "Available only",
    men: "Men",
    women: "Women",
    // Export image
    exportImage: "Export Image",
    // Required servers
    requiredServers: "Required servers",
    requiredServersPlaceholder: "Number of servers needed",
    // Confirmations
    confirmedAssignment: "Confirmed",
    unconfirmedAssignment: "Unconfirmed",
    confirmedCount: "{count} confirmed",
    continueMarkingAttendance: "Continue marking attendance",
    viewSummary: "View summary",
    addService: "Add service",
    serviceFormRequiredServers: "Required servers",
    serviceFormRequiredServersPlaceholder: "Number of servers needed",
    serviceFormType: "Service type",
    serviceFormTypePlaceholder: "Select or type a new type and press +",
    previewReport: "Preview report",
    reportPreview: "Report preview",
    paymentMethod: "Payment method",
    paymentType: "Payment type",
    deleteMeeting: "Delete meeting",
    editMeeting: "Edit meeting",
    markedAttendance: "Marked as attended",
    manualEntry: "Manual entry",
    addManually: "Add manually",
    groupServersServicesTitle: "Group server services",
    groupServersServicesAddAll: "Add all servers to all services",
    groupServersServicesRemoveAll: "Remove all servers from all services",
    isCancelled: "Cancelled",
    addMeeting: "Add Meeting",
    addDate: "Add Date",
    addNextDate: "Add Next Date",
    nextDates: "Upcoming dates",
    previousDates: "Previous dates",
    editDate: "Edit Date",
    titleRequired: "Title is required",
    startDateRequired: "Start date is required",
    startTimeRequired: "Start time is required",
    endTimeRequired: "End time is required",
    dayOfWeekRequired: "Day of week is required",
    repeatEveryInvalid: "Repeat option is invalid",
    statusRequired: "Status is required",
    dragToReorder: "Drag to reorder",
    requiredServersCount: "{count} required servers",
    serversRequiredSuffix: "required servers",
    attendanceDashboard: "Attendance Dashboard",
    attendanceTrend: "Attendance Trend",
    topAttendance: "Top Attendance",
    bottomAttendance: "Bottom Attendance",
    serviceCoverage: "Service Coverage",
    attendanceByServer: "Attendance by Server",
    sortDescending: "Sort Descending",
    sortAscending: "Sort Ascending",
    totalServers: "Total Servers",
    attendanceRateTitle: "ATTENDANCE RATE",
    averageAttendanceTitle: "AVERAGE ATTENDANCE",
    peoplePerMeeting: "people per meeting",
    meetingsTitle: "MEETINGS",
    inThisPeriod: "in this period",
    activeServersTitle: "ACTIVE SERVERS",
    uniqueServers: "unique servers",
    vsPreviousPeriod: "vs. previous period",
    noChanges: "no changes",
    totalServersTitle: "TOTAL SERVERS",
    servingMarriedTitle: "MARRIED COUPLES SERVING",
    singlesTitle: "SINGLES",
    sheepTitle: "SHEEP",
    viewDetail: "View detail",
    marriedTotal: "married in total",
    spouseNotServing: "spouse not serving",
    inFreeUnion: "in cohabitation",
    pastorsWithSheep: "pastors with sheep",
    ageSegmentationTitle: "AGE SEGMENTATION",
    serverBirthdaysTitle: "SERVER BIRTHDAYS",
    todaysBirthdays: "TODAY'S BIRTHDAYS",
    noBirthdaysToday: "No servers celebrate birthdays today",
    serversCelebrateInMonth: "{count} servers celebrate in {month}",
    viewAllBirthdays: "View all birthdays",
    celebratingThisMonth: "celebrating birthdays",
    noBirthdaysInMonth: "No birthdays registered for this month",
    turnsYears: "Turns {age} years",
    todayBirthdayBadge: "Today!",
    serversOutsideConfiguredRanges: "servers outside configured ranges",
    configure: "Configure",
    configureAgeRanges: "Configure Age Ranges",
    ageRangesDesc: "Define age ranges to segment servers. Ranges must not overlap.",
    fromAge: "From",
    toAge: "To",
    addRange: "Add range",
    reset: "Reset",
    valuesMustBePositive: "Values must be positive",
    minMustBeLessThanMax: "Range {index}: min must be less than max",
    rangesMustNotOverlap: "Ranges must not overlap",
    bothServe: "Both serve",
    onlyOneServes: "Only one serves",
    totalAttendance: "Total attendance",
    averageLabel: "average",
    totalAveragePerMeeting: "Average total per meeting",
    peopleLabel: "people",
    marriedCouplesTitle: "Married Couples",
    searchServerOrSpouse: "Search server or spouse...",
    noResultsFound: "No results found",
    printQR: "Print QR",
    downloadQR: "Download QR",

    qrModalTitle: "Attendance QR Code",
    attendanceSystemSubtitle: "Attendance System",
    communityTag: "Community",
    scanToMarkAttendance: "SCAN TO MARK ATTENDANCE",
    qrScanDescription: "Open your phone camera to automatically check in for attendance",
    meetingNotFoundTitle: "Meeting Not Found",
    meetingNotFoundDesc:
      "The QR code or link appears to be invalid. Please request a new QR code from your group leader.",
    attendanceNotAvailableTitle: "Attendance Not Available",
    attendanceNotAvailableDesc:
      "Attendance can only be marked on the day of the meeting during the configured schedule.",
    meetingScheduleLabel: "Meeting schedule:",
    allowedMarginNotice: "Allowed window: 2 hours before and after the scheduled start time.",
    step1Of2: "STEP 1 OF 2",
    selectYourNameTitle: "Select your name",
    selectYourNameDesc: "Find your name in the list to save your identity on this device for the next 2 weeks.",
    searchPlaceholder: "Search name, phone or email",
    noNamesFound: "No names found.",
    registeredServer: "Registered Member",
    changeUserButton: "Change",
    changeUserTitle: "Change person",
    attendanceMarkedSuccessTitle: "Attendance Confirmed!",
    attendanceMarkedSuccessDesc: "Your attendance has been successfully confirmed for today.",
    pressButtonToMarkAttendance: "Press the button below to mark your attendance:",
    markAttendanceButton: "MARK ATTENDANCE",
    attendanceMarkErrorDesc: "Could not mark attendance. Please try again.",
    goToCheckInPage: "Go to Check-in Page",
    viewQR: "View QR Code",
    serverAssignments: "Server Assignments",
    serverAssignmentsDesc: "Check the ranking of servers with the most and least assignments.",
    sortBy: "Sort by",
    serverAssignmentsRank: "Server Assignments Rank",
    mostAssigned: "Most Assigned",
    leastAssigned: "Least Assigned",
    servicesAssigned: "services assigned",
    viewDetails: "View details",
    totalServicesAssigned: "Total assigned services",
    serviceType: "Service Type",
    noServicesAssigned: "No services assigned",
    backToList: "Back to list",
    noData: "No data",
    noHistoryFound: "No history found.",
    allMeetings: "All Meetings",
    serviceHistory: "Service History",
    managers: "Managers",
    replacements: "Replacements",
    statusOptionActives: "Active",
    statusOptionDeclined: "Inactives",
    photoPendingOnly: "Photo pending",
    guestGridFilterUnder25: "Menores de 25",
    guestGridFilterAbove25: "Mayores de 25",
    guestGridFilterNotSingle: "No soltero/a",
    guestGridFilterSingle: "Soltero/a",
    workshopsCountInvalid: "The number of workshops cannot be negative",
    scrollToTop: "Scroll to top",
    ...commitmentTranslations.en
  },

  es: {
    comuTitle: "Comunidad Católica El Salvador del Mundo",
    mainPhrase: "Unidos en fe y servicio a nuestra comunidad.",
    copyright: "Comunidad Católica El Salvador del Mundo. Todos los derechos reservados.",
    close: "Cerrar",
    loginWelcomeMessage: "Bienvenido/a!",
    loginPasswordPlaceholder: "Contraseña",
    loginUserPlaceholder: "Usuario (email)",
    loginButtonText: "Continuar",
    loginBiblicalQuote: `Entonces el Señor me dijo: “Habla en mi nombre a estos huesos. Diles: ‘Huesos secos, escuchad este mensaje del
          Señor. El Señor os dice: Voy a hacer entrar en vosotros aliento de vida, para que reviváis. Os pondré
          tendones, os rellenaré de carne, os cubriré de piel y os daré aliento de vida para que reviváis.
          Entonces reconoceréis que yo soy el Señor.`,
    loginBiblicalQuoteReference: "Ezequiel 37:4-6",
    loginUserNameRequired: "El usuario es requerido",
    loginPasswordRequired: "La contraseña es requerida",
    loginGenericError: "Ocurrió un error. Por favor inténtalo de nuevo más tarde.",
    forgotPassword: "¿Olvidaste tu contraseña?",
    forgotPasswordTitle: "Restablecer contraseña",
    forgotPasswordDescription: "Ingresa tu correo y te enviaremos un enlace para restablecer tu contraseña.",
    forgotPasswordEmailPlaceholder: "tu@correo.com",
    forgotPasswordSuccess:
      "¡Revisa tu bandeja de entrada! Si ese correo está registrado, recibirás el enlace en breve.",
    forgotPasswordError: "Algo salió mal. Por favor inténtalo de nuevo.",
    resetPasswordTitle: "Crea una nueva contraseña",
    resetPasswordDescription: "Ingresa tu nueva contraseña.",
    resetPasswordButton: "Guardar contraseña",
    resetPasswordSuccess: "Tu contraseña fue actualizada. Ya puedes iniciar sesión con tu nueva contraseña.",
    resetPasswordInvalidLink: "Este enlace no es válido o ha expirado. Por favor solicita uno nuevo.",
    resetPasswordMinLength: "La contraseña debe tener al menos 6 caracteres",
    goToLogin: "Ir a iniciar sesión",
    send: "Enviar",
    contact: "Contacto",
    genericErrorTitle: "Ocurrío un error",
    mainMenuHome: "Inicio",
    mainMenuEvents: "Retiros",
    mainMenuServices: "Asambleas",
    mainMenuSecurity: "Seguridad",
    mainMenuInvitations: "Invitaciones",
    mainMenuCommitments: "Compromiso",
    mainMenuPrayerRequests: "Peticiones",
    mainMenuPreaching: "Predicas",
    eventFilterTitle: "Filtros Principales",
    eventFilterGroupPlaceholder: "Grupos",
    eventFilterPlaceholder: "Retiros",
    logout: "Cerrar Sesión",
    myProfile: "Mi Perfil",
    profilePersonalInfo: "Información Personal",
    profileFullName: "Nombre Completo",
    profileEmail: "Correo Electrónico",
    profilePhone: "Teléfono",
    profileBirthDate: "Fecha de Nacimiento",
    profileLocation: "Ubicación",
    profileSecurity: "Seguridad",
    profileChangePassword: "Cambiar Contraseña",
    profileTwoFactor: "Autenticación de Dos Pasos",
    profileUploadPhoto: "Subir foto",
    profileRoleAdmin: "Administrador",
    profileRoleUser: "Miembro",
    profileTwoFactorDisabled: "Desactivado",
    profileTwoFactorEnabled: "Activado",
    profilePreferences: "Preferencias",
    profileNotifications: "Notificaciones",
    profileLanguage: "Idioma",
    profileCurrentPassword: "Contraseña actual",
    profileNewPassword: "Nueva contraseña",
    profileConfirmPassword: "Confirmar nueva contraseña",
    profilePasswordChanged: "¡Contraseña cambiada!",
    profilePasswordChangedDesc: "Tu contraseña ha sido actualizada exitosamente.",
    profileWrongPassword: "La contraseña actual es incorrecta. Inténtalo de nuevo.",
    profileChangePasswordError: "Ocurrió un error. Por favor inténtalo de nuevo más tarde.",
    profilePasswordMinLength: "La contraseña debe tener al menos 8 caracteres",
    profilePasswordsNoMatch: "Las contraseñas no coinciden",
    eventMenuInscription: "Nueva ficha",
    eventMenuIncome: "Fichas",
    eventMenuRooms: "Habitaciones",
    eventMenuComissions: "Comisiones",
    eventMenuWorkshops: "Talleres",
    eventMenuDashboard: "Pagos",
    eventMenuSummaryByGroup: "Resumen por Grupo",
    eventMenuServers: "Servidores",
    eventMenuAttendance: "Control de asistencia",
    eventMenuDashboardTitle: "Resumen del retiro",
    eventMenuPrint: "Imprimir",
    eventMenuConfig: "Configuración",
    eventMenuFilters: "Filtros",
    eventMenuRefresh: "Actualizar",
    eventMenuMoveParticipants: "Mover participantes",
    moveParticipantsTitle: "Mover participantes",
    moveParticipantsSelectParticipants: "Selecciona participantes a mover",
    moveParticipantsSelectEvent: "Selecciona el evento destino",
    moveParticipantsConfirm: "Mover",
    moveParticipantsSuccess: "Participantes movidos correctamente",
    moveParticipantsNoneSelected: "Selecciona al menos un participante",
    moveParticipantsAlreadyExists: "ya existe en este evento",
    searchParticipant: "Buscar participante...",
    selectAll: "Seleccionar todos",
    deselectAll: "Deseleccionar todos",
    next: "Siguiente",
    back: "Atrás",
    genericError: "Ocurrió un error",
    eventMenuCalls: "Llamadas",
    guestGridSearchPlaceholder: "Buscar...",
    guestGridColPhone: "Teléfono",
    guestGridColName: "Nombre",
    guestGridColLastName: "Apellido",
    guestGridColAge: "Edad",
    guestGridColGender: "Sexo",
    guestGridColGroup: "Grupo",
    guestGridColMaritalStatus: "Estado Civil",
    guestGridColSpecialFood: "Dieta Esp",
    guestGridColHasIllnes: "Padecimiento",
    guestGridColExtraFood: "Comida Extra",
    guestGridColExtraStay: "Estadia Extra",
    guestGridColConvertionDate: "Fecha de Conversión",
    guestGridColStatus: "Estado",
    guestGridColPaymentStatus: "Estado de Pago",
    guestGridColCalls: "Llamadas",
    guestGridFiltersTitle: "Filtros",
    guestGridColVechicle: "Vehículo",
    guestGridFilterGuests: "Participantes",
    guestGridFilterMovements: "Movimientos",
    guestGridColWhoRecommended: "Recomendado por",
    guestGridFilterServers: "Servidores",
    guestGridFilterAll: "Todos",
    guestGridFilterConfirmed: "Confirmados",
    guestGridFilterInvited: "Invitados",
    guestGridFilterRegistered: "Inscritos",
    guestGridFilterPending: "Pendientes",
    guestGridFilterNext: "Próximo",
    guestGridFilterDeclined: "Cancelados",
    guestGridFilterPaymentComplete: "Pago Completado",
    guestGridFilterPaymentPending: "Pago Pendientes",
    guestGridFilterPaymentPartial: "Parciales",
    guestGridFilterEspetialFood: "Dieta Especial",
    guestGridFilterIllness: "Padecimiento",
    guestGridFilterMale: "Hombres",
    guestGridFilterFemale: "Mujeres",
    guestGridFilterBringingVehicle: "Lleva Vehículo",
    guestGridFilterNoAttendance: "No asistió",
    guestGridFilterItAttendance: "Asistió",
    guestGridFilterExtraStay: "Estadia Extra",
    guestGridFilterExtraFood: "Comida Extra",
    guestGridFilterType: "Tipo",
    guestGridFilterStatus: "Estado de Confirmación",
    guestGridFilterPayment: "Estado de Pago",
    guestGridFilterIssues: "Buscar por Padecimientos",
    guestGridFilterGender: "Sexo",
    guestGridFilterAttendance: "Asistencia",
    guestGridFilterOther: "Otros",
    guestGridFilterAge: "Edad",
    guestGridFilterMaritalStatus: "Estado Civil",
    meetingServiceStartTime: "Hora de Inicio",
    meetingServiceEndTime: "Hora de Fin",
    startTime: "Hora de Inicio",
    endTime: "Hora de Fin",
    selectMeeting: "Seleccionar una reunión",
    changeMeeting: "Cambiar reunión",
    noTitle: "Sin título",
    selectDate: "Seleccionar fecha",
    nextDates: "Próximas fechas",
    previousDates: "Fechas anteriores",
    currentMeeting: "Reunión actual",
    searchMeeting: "Buscar reunión",
    current: "Actual",
    noScheduledDates: "Sin fechas programadas",
    newMeeting: "Nueva reunión",
    createAndSchedule: "Crear y programar",
    meetingDate: "Fecha de la reunión",
    dateAssociatedWithSelectedMeeting: "Fecha asociada a la reunión seleccionada",
    changesWillReflectInAttendanceList: "Los cambios se reflejarán en la lista de asistencia",
    availableServers: "Servidores Disponibles",
    noAssignedServers: "Aún no hay servidores asignados",
    assignedServers: "Servidores Asignados",
    assign: "Asignar",
    total: "Total",
    male: "Masculino",
    female: "Femenino",
    add: "Agregar",
    save: "Guardar",
    delete: "Eliminar",
    married: "Casado (a)",
    single: "Soltero (a)",
    divorced: "Divorciado (a)",
    widowed: "Viudo (a)",
    accompaned: "Acompañado (a)",
    yes: "Si",
    no: "No",
    confirmed: "Confirmado",
    verified: "Verificado",
    invited: "Ingresado",
    callPending: "Llamada Pendiente",
    nextTime: "Próxima Vez",
    pending: "Pendiente",
    paymentComplete: "Completo",
    paymentPartial: "Parcial",
    brand: "Marca",
    plate: "Placa",
    transfer: "Transferencia",
    cash: "Efectivo",
    check: "Cheque",
    other: "Otro",
    edit: "Editar",
    call: "Llamada",
    date: "Fecha",
    eventDoneMessage: "El retiro ya fue realizado el {date}",
    addInvitation: "Crear invitación",
    servicesTabTitle: "Asambleas",
    serversTabTitle: "Servidores",
    groupServersEdit: "Detalles del Servidor",
    groupServersGridTitle: "Servidores del Grupo",
    groupServersGridColName: "Nombre",
    attendancePendingTitle: "Pendientes de Asistencia",
    attendanceMaleLength: "{count} Hombre(s)",
    attendanceFemaleLength: "{count} Mujer(es)",
    attendanceTotalLength: "{count} Total",
    attendanceByGender: "Asistencia por Sexo",
    attendanceNotToday: "La asistencia solo se puede marcar los dias del retiro ({date}).",
    // Generic
    cancel: "Cancelar",
    loading: "Cargando...",
    uploadImage: "Subir imagen",
    reload: "Recargar",
    oops: "Oops!",
    active: "Activo",
    inactive: "Inactivo",
    saving: "Guardando...",
    sending: "Enviando...",
    deleting: "Eliminando...",
    view: "Ver",
    hide: "Ocultar",
    commentsLabel: "Comentarios",
    nameRequired: "El nombre es requerido",
    descriptionLabel: "Descripción",
    descriptionRequired: "La descripción es requerida",
    meetingSchedule: "Programación de reunión",
    dangerZone: "Zona de peligro",
    actionCannotBeUndone: "Esta acción no se puede deshacer",
    errorOccurredWith: "Ocurrio un error: {error}",
    // Days of week
    sunday: "Domingo",
    monday: "Lunes",
    tuesday: "Martes",
    wednesday: "Miércoles",
    thursday: "Jueves",
    friday: "Viernes",
    saturday: "Sábado",
    // Status badges
    statusInvited: "Ingresado",
    statusConfirmed: "Confirmado",
    statusDeclined: "no asistirá",
    statusNextTime: "Siguiente",
    statusCallPending: "Pendiente de llamada",
    // Payment status badges
    paymentPartialBadge: "Pago Parcial",
    paymentPaidBadge: "Pagado",
    paymentOverpaidBadge: "El participante ha pagado de más",
    paymentPendingBadge: "Pago Pendiente",
    // Auth module
    filterByGroup: "Filtrar por grupo",
    allGroups: "Todos los grupos",
    emailLabel: "Correo",
    nameLabel: "Nombre",
    passwordLabel: "Contraseña",
    generatePassword: "Generar Contraseña",
    enabled: "Habilitado",
    adminLabel: "Administrador",
    selectRole: "Selecciona un rol",
    selectGroupOption: "Selecciona un grupo",
    selectEvent: "Selecciona un evento",
    newUser: "Nuevo Usuario",
    errorCreatingUser: "Error al crear el usuario",
    allFieldsRequired: "Todos los campos son requeridos",
    systemUsers: "Usuarios del sistema",
    searchUser: "Buscar usuario",
    newUserButton: "Nuevo usuario",
    usernameColumn: "Usuario",
    changePassword: "Cambiar contraseña",
    newPassword: "Nueva contraseña",
    // Security admin tabs
    securityTabUsers: "Usuarios",
    securityTabRoles: "Roles",
    securityTabGroups: "Grupos",
    searchRole: "Buscar rol...",
    usersWithRole: "Usuarios con este rol",
    roleModule_groups: "Grupos e invitados",
    roleModule_workshopsRooms: "Talleres y habitaciones",
    roleModule_payments: "Pagos",
    roleModule_events: "Eventos",
    roleModule_invitations: "Invitaciones",
    roleModule_services: "Servicios y reuniones",
    roleModule_commitments: "Compromisos",
    roleModule_prayerRequests: "Peticiones de oración",
    roleModule_preaching: "Predicación",
    roleModule_administration: "Administración",
    roleModule_other: "Otros",
    noGroupsAvailable: "No hay grupos disponibles",
    usersInGroup: "Usuarios en este grupo",
    searchGroup: "Buscar grupo...",
    noUsersFound: "No se encontraron usuarios",
    usersCount: "{count} usuarios",
    // Groups module
    addGroup: "Agregar grupo",
    groupConfig: "Configuración de grupo",
    newGroup: "Nuevo Grupo",
    codeLabel: "Código",
    groupCodeLabel: "Codigo",
    groupCodePlaceholder: "Codigo (utilizado para la url)",
    saveChanges: "Guardar Cambios",
    createGroup: "Crear Grupo",
    columnCommission: "Comisión",
    columnCreatedAt: "Creacion",
    // Invitations module
    signMeUp: "Inscribirme",
    selectServer: "Selecciona un servidor",
    inscriptionSuccess: "Inscripción exitosa",
    guestList: "Lista de invitados",
    openLink: "Abrir enlace",
    invitationTitleLabel: "Titulo",
    invitationStartDate: "Fecha de inicio",
    invitationLocation: "Ubicación",
    invitationTitleRequired: "El título es requerido",
    invitationCodeRequired: "El código es requerido",
    invitationStartDateRequired: "La fecha de inicio es requerida",
    invitationStatusRequired: "El estado es requerido",
    invitationDisplaySettings: "Configuración de visualización",
    invitationShowServerList: "Mostrar lista de servidores",
    invitationHideCustomFields: "Ocultar formulario de inscripción",
    invitationHideDetails: "Ocultar detalles del evento",
    invitationCustomFieldsTitle: "Campos del formulario de inscripción",
    invitationAddCustomField: "Agregar campo",
    invitationNoCustomFields: "Aún no se han agregado campos",
    invitationCustomFieldLabel: "Etiqueta",
    invitationCustomFieldName: "Identificador",
    invitationCustomFieldType: "Tipo",
    invitationCustomFieldRequired: "Requerido",
    invitationFieldTypeText: "Texto",
    invitationFieldTypeEmail: "Correo",
    invitationFieldTypePhone: "Teléfono",
    invitationFieldTypeCheckbox: "Casilla",
    invitationFieldLabelRequired: "La etiqueta es requerida",
    invitationFieldNameRequired: "El identificador es requerido",
    invitationFieldNameDuplicated: "Los identificadores no se pueden repetir",
    addGuestButton: "Agregar invitado",
    addGuestPlaceholder: "Agregar Invitado",
    // Prayer requests module
    prayerRequestEntries: "Entradas",
    prayerRequestText: "Petición",
    prayerRequestCount: "peticiones",
    exportXLS: "Exportar XLS",
    exportPDF: "Exportar PDF",
    noEntries: "No hay entradas registradas",
    editPrayerRequest: "Editar Petición",
    newPrayerRequest: "Nueva Petición",
    prayerRequestCodeLabel: "Código (Ruta pública)",
    prayerRequestAvatarUrl: "URL Avatar (opcional)",
    prayerRequestBannerUrl: "URL Banner (opcional)",
    prayerRequestStatusLabel: "Estado",
    confirmDeletePrayerRequest: "¿Seguro que quieres eliminar esta petición?",
    prayerRequestModule: "Módulo de Peticiones",
    noPrayerRequests: "No hay peticiones configuradas.",
    prayerRequestNotFound: "Petición no encontrada",
    prayerRequestInvalidLink: "Este enlace ya no es válido o ha sido desactivado.",
    prayerRequestSent: "¡Petición enviada!",
    prayerRequestSentMessage: "Gracias por compartir tu petición. Estaremos orando por ti.",
    sendAnotherRequest: "Enviar otra petición",
    writeYourRequest: "Escribe tu petición",
    writeYourRequestPlaceholder: "Escribe aquí tu petición. Es completamente anónimo.",
    sendRequest: "Enviar petición",
    // Payment form
    fileRequired: "Debe seleccionar un archivo",
    amountRequired: "El monto debe ser mayor a 0",
    paymentSentSuccess: "Comprobante de pago enviado correctamente",
    paymentTypeLabel: "Tipo de pago",
    movementTypeLabel: "Tipo de movimiento",
    creditOption: "Abono",
    refundOption: "Devolución",
    amountLabel: "Monto",
    amountAutoFill: "El monto se autocompletará si se sube un comprobante",
    totalPaidNegativeError: "El monto total abonado no puede ser menor a 0",
    analyzingReceipt: "Analizando comprobante...",
    receiptAmount: "Monto del comprobante",
    uploadReceipt: "Subir comprobante",
    multiplePaymentQuestion: "El pago aplica a multiples participantes?",
    selectParticipantsForPayment: "Seleccionar participantes a los que aplica el pago",
    paymentCommentsLabel: "Comentarios",
    paymentCommentsPlaceholder: "Comentarios del pago",
    sendAnotherReceipt: "Enviar otro comprobante",
    errorSendingReceipt: "Error al enviar el comprobante",
    errorAnalyzingReceipt: "No se pudo analizar el comprobante, ingresa el monto manualmente",
    amountNotFoundOnReceipt: "No se pudo leer el monto del comprobante, ingrésalo manualmente",
    // Guest module
    vehicleInfo: "Información del vehículo",
    saveVehicleInfo: "Guardar Información del vehículo",
    callHistory: "Historial de llamadas",
    notSpecified: "No especificado",
    noCallsRegistered: "No se han registrado llamadas",
    newCall: "Nueva llamada",
    deleteParticipant: "Eliminar participante",
    deleteServer: "Eliminar servidor",
    assignedServer: "Servidor asignado",
    callerNameLabel: "Nombre del servidor",
    dateRequired: "La fecha es requerida",
    serverNameRequired: "El nombre del servidor es requerido",
    groupServersGridColPhone: "Teléfono",
    groupServersGridColGender: "Sexo",
    attendanceTitle: "Asistencia",
    attendanceIndicatorTitle: "Conteo de Asistencia",
    groupServersGridColLastName: "Apellido",
    groupServersGridColMaritalStatus: "Estado Civil",
    groupServersGridColConvertionDate: "Fecha de Conversión",
    groupServersGridColEmail: "Correo",
    noAccessText: "No tienes permisos para acceder a este recurso",
    meetingOfDay: "Reunión del día {day}",
    meetingServiceFormServiceName: "Agregar comisión",
    meetingServiceFormDescription: "Descripción",
    meetingServiceFormDate: "Fecha del servicio",
    meetingServiceFormTitle: "Título de la reunión",
    meetingServiceFormTitlePlaceholder: "Título de la reunión",
    serviceFormTitle: "Título del servicio",
    serviceFormTitlePlaceholder: "Título del servicio",
    serviceFormDescription: "Descripción del servicio",
    serviceFormDescriptionPlaceholder: "Descripción del servicio",
    serviceFormAdditionalNotes: "Notas Adicionales",
    serviceFormAdditionalNotesPlaceholder: "Notas adicionales del servicio",
    addServer: "Agregar servidor",
    editServer: "Editar servidor",
    attendanceGridColName: "Nombre",
    attendanceGridColAge: "Edad",
    attendanceGridColLastName: "Apellido",
    attendanceGridColPhone: "Teléfono",
    attendanceGridColRoom: "Habitación",
    attendanceGridColHouse: "Casa",
    attendanceGridColWorkshop: "Taller",
    attendanceGridColAttendance: "Asistencia",
    attendanceGridColPayment: "Pago",
    attendanceGridColViewProfile: "Ver Perfil",
    assignWorkshopsByAge: "Asignar talleres por edad",
    assignWorkshopsRandomly: "Asignar talleres aleatoriamente",
    groups: "Grupos",
    all: "Todos",
    of: "de",
    paymentsList: "Lista de pagos",
    rooms: "Habitaciones",
    roomsNoEditAccess: "No tienes permisos para editar habitaciones",
    currentTotalServers: "Total actual de servidores",
    groupByAgeBarChartTitle: "Servidores por Edad",
    groupByMaritalStatusBarChartTitle: "Servidores por Estado Civil",
    groupByMinistryBarChartTitle: "Servidores por Ministerio",
    groupByConvertionYearsBarChartTitle: "Servidores por Años de Conversión",
    nextRetreats: "Próximos retiros",
    available: "Disponible",
    notAvailable: "No Disponible",
    priests: "Sacerdotes",
    firstFloor: "1er Nivel",
    secondFloor: "2do Nivel",
    marysHouse: "Casa de María",
    searchRoomsPlaceholder: "Buscar por número de habitación...",
    noConnection: "No hay conexión a internet",
    confirmUpdateWorkshopsByAge: "¿Estás seguro de querer actualizar los talleres por edad?",
    configWorkshopsCount: "Configurar cantidad de talleres",
    uploadPayment: "Subir Pago",
    paymentsHistory: "Historial de pagos",
    accept: "Aceptar",
    availableBeds: "Camas Disp",
    dashboard: "Dashboard",
    assignedServices: "Asignación",
    assignServices: "Asignar Servicios",
    assignServicesCaption: "Asigna servidores a los servicios para las próximas reuniones",
    selectMeetingHelperText: "Por favor selecciona una reunión para comenzar a asignar servicios",
    serversManagement: "Administración de Servidores",
    serversManagementCaption: "Administra servidores y sus habilidades de servicio",
    noMeetingSelected: "No hay reunión seleccionada",
    servicesManagement: "Administración de Servicios",
    servicesManagementCaption: "Administra los diferentes servicios necesarios para las reuniones",
    services: "Servicios",
    upcommingMeetings: "Próximas reuniones",
    upcommingMeetingsCaption: "Ver y administrar las próximas reuniones",
    calendar: "Calendario",
    calendarCaption: "Selecciona una fecha para ver las reuniones",
    serviceStats: "Estadísticas de Servicio",
    serviceStatsCaption: "Resumen de las asignaciones de servicio",
    quickActions: "Acciones Rápidas",
    quickActionsCaption: "Tareas y acciones comunes",
    filterByCallName: "Filtrar por encargado",
    filteredByCallerName: "Filtrado por encargado: {callerName}",
    allCallers: "Todos los encargados",
    paymentNotes: "Notas de Pago",
    paymentNotesPlaceholder: "Agregar notas de pago (becas o descuentos)",
    history: "Historial",
    noRecordsFound: "No se encontraron registros",
    results: "resultados",
    selectEventPlaceholder: "Seleccionar un retiro",
    groupHasNoEvents: "El grupo no tiene retiros disponibles",
    createNewEvent: "Crear nuevo retiro",
    openFilters: "Abrir Filtros",
    filtersApplied: "Filtros Aplicados",
    paymentGeneralDetails: "Detalles Generales de Pago",
    noPayments: "No hay pagos",
    refund: "Reembolso",
    noResults: "No se encontraron resultados",
    noNextRetreats: "No hay próximos retiros disponibles",
    addMeeting: "Agregar Reunión",
    selectNextMeeting: "Seleccionar Reunión",
    attendanceGridColSpecialFood: "Dieta Especial",
    service: "Servicio",
    lastServer: "Último Servidor",
    noMeetingDataAvailable: "No hay datos de reunión disponibles",
    removeMeetingService: "Eliminar Servicio de Reunión",
    meetingAttendance: "Asistencia",
    meetingAttendanceCaption: "Marcar asistencia de servidores en cada reunión",
    markAttendance: "Marcar asistencia",
    noMeetingAttendanceData: "No hay datos de asistencia para esta reunión",
    attended: "Asistió",
    notAttended: "No asistió",
    replaceServer: "Reemplazar",
    manualEntry: "Entrada manual",
    attendedCount: "{count} asistieron",
    attendedNoCount: "{count} ausencias",
    justifiedCount: "{count} justificadas",
    attendedSuffix: " (Asistió) ✅",
    referenceMeetingForAttendance: "Revisar asistencia de:",
    eventWorkshopsAddWorkshop: "Agregar Taller",
    workshopsCountMalePlaceholder: "Cantidad de talleres para hombres",
    workshopsCountMaleLabel: "Talleres para hombres",
    workshopsCountFemalePlaceholder: "Cantidad de talleres para mujeres",
    workshopsCountFemaleLabel: "Talleres para mujeres",
    workshopsCountConfigDisabled: "No se puede modificar la configuración de talleres",
    automaticWorkshopAssignment: "Asignación automática de talleres",
    workshopCannotEdit: "No se puede modificar la configuración",
    workshopConfigSaveChanges: "Cambios guardados al guardar",
    workshopConfigSaveChangesDisabled: "No se puede modificar la configuración",
    workshopsCountMaleDisabled: "No se puede modificar la cantidad de talleres para hombres (ya hay asignados).",
    workshopsCountFemaleDisabled: "No se puede modificar la cantidad de talleres para mujeres (ya hay asignadas).",
    autoAssignRooms: "Reservar cuartos para servidores aleatoriamente",
    registersFound: "registros encontrados",
    changeStatus: "Cambiar Estado",
    guestProfile: "Información",
    guestPayments: "Pagos",
    guestCallList: "Lista de Llamadas",
    guestCarInfo: "Información del Vehículo",
    updateInfoText: "Actualizar Información",
    guestAdminTools: "Herramientas de Administración",
    eventForm: {
      formType: {
        tob: "Retiro TOB",
        initial: "Retiro de conversión",
        initialForeign: "Retiro de conversión en el extranjero",
        marriage: "Retiro de matrimonio"
      },
      genderType: {
        male: "Hombres",
        female: "Mujeres",
        both: "Mixto"
      }
    },
    // Preaching module
    preachingEventsTab: "Predicas",
    preachingSermonsTab: "Predicas",
    preachingMeetingsTab: "Reuniones",
    preachingPreferencesTab: "Preferencias",
    preachingMyPreachingsTab: "Mis prédicas",
    preachingUpcomingEvents: "Próximas predicas",
    preachingUpcomingEventsCaption: "Eventos de predica próximos programados",
    preachingRecentSermons: "Predicas Recientes",
    preachingRecentSermonsCaption: "Últimas predicas agregadas",
    preachingNextMeeting: "Próxima Reunión de Planificación",
    preachingNextMeetingCaption: "Detalles de la próxima reunión de planificación",
    preachingPeriod: "Período",
    preachingNewEvent: "Nuevo Evento",
    preachingNewSermon: "Nueva Predica",
    preachingNewMeeting: "Nueva Reunión",
    preachingNewPreference: "Nueva Preferencia",
    preachingGenerateAssignments: "Generar Asignaciones",
    preachingScheduleTab: "Calendarización",
    preachingUpcomingOnly: "Ver próximas",
    preachingSelectMeeting: "Seleccioná una reunión para ver su detalle",
    preachingNoEventsInPeriod: "No hay prédicas en este período",
    preachingGenerateConfirmation:
      "¿Estás seguro de generar asignaciones automáticas? Esto asignará predicadores a eventos según las reglas configuradas.",
    preachingAssignedCount: "{count} asignaciones generadas",
    preachingUnassignedSlots: "{count} espacios no pudieron ser asignados",
    preachingPreacher: "Predicador",
    preachingGroup: "Grupo",
    preachingStatus: "Estado",
    preachingRating: "Calificación",
    preachingEventDetails: "Detalles del Evento",
    preachingSermonDetails: "Detalles de la Predica",
    preachingSermonTitle: "Título",
    preachingMeetingDetails: "Detalles de la Reunión",
    preachingMeetingDate: "Fecha de Reunión",
    preachingPlanningStart: "Inicio de Planificación",
    preachingPlanningEnd: "Fin de Planificación",
    preachingPreferenceDetails: "Detalles de Preferencia",
    preachingAllowedZones: "Zonas Permitidas",
    preachingAllZones: "Todas las zonas (sin restricción)",
    preachingZonesHelp: "Dejar vacío para permitir todas las zonas",
    preachingNoPreferences: "No hay preferencias configuradas",
    preachingPreacherActive: "Predicador activo",
    preachingZonesRequired: "Selecciona al menos una zona para guardar",
    preachingMissingPreacherHint:
      "¿No aparece un predicador? Debe estar inscrito en el compromiso vigente con el ministerio Prédica. Cada predicador puede configurar sus zonas desde su propio perfil.",
    preachingNoAttendanceRecords: "No hay registros de asistencia",
    preachingSearchPreachers: "Buscar predicadores por nombre o teléfono...",
    preachingAttendance: "Asistencia",
    preachingSaveAttendance: "Guardar Asistencia",
    preachingAttendanceSaveFailed: "No se pudo guardar. Intentá de nuevo.",
    preachingStatusDraft: "Borrador",
    preachingStatusPublished: "Publicada",
    preachingStatusArchived: "Archivada",
    preachingStatusScheduled: "Programada",
    preachingStatusInProgress: "En Progreso",
    preachingStatusCompleted: "Completada",
    preachingStatusCancelled: "Cancelada",
    preachersAvailable: "Predicadores Disponibles",
    preachersAvailableDesc:
      "Lista de servidores de compromiso asociados al ministerio de PREDICA. Edita su estado y comentarios a continuación.",
    inTraining: "En Entrenamiento",
    preachersTotalPreachings: "Predicas",
    preachersGroupsServed: "Grupos",
    preachersLastPreaching: "Última predica",
    preachersAvgAttendance: "Asistencia prom.",
    preachersHistory: "Historial de Predicas",
    preachersSelectToView: "Selecciona un predicador para ver su historial",
    preachersNoHistory: "No se encontraron predicas para este predicador",
    preachersStatusLabel: "Estado del predicador",
    preachersAllStatuses: "Todos los estados",
    addComment: "Añadir comentario...",
    search: "Buscar...",
    zones: {
      title: "Zonas",
      central: "Central",
      paracentral: "Paracentral",
      oriental: "Oriental",
      occidental_santa_ana: "Occidental - Santa Ana",
      occidental_sonsonate: "Occidental - Sonsonate"
    },
    otherGroupConfigs: "Otras configuraciones de grupo",
    isVirtual: "Es virtual",
    isVisible: "Es visible (aparece en público)",
    dropImageHere: "Arrastra la imagen aquí o haz click para seleccionar",
    isWithMeeting: "Es con asamblea",
    signinServerTitle: "Iniciar sesión como servidor",
    signinServerDescription:
      "Ingresa con el correo que ingresaste en la inscripción del compromiso para acceder a tu perfil de servidor y gestionar tus servicios asignados.",
    loginConfirmPasswordPlaceholder: "Confirmar contraseña",
    signinServerButtonAction: "Registrarme",
    signinSuccess: "¡Inicio de sesión exitoso! Redirigiendo a tu perfil...",
    signinFailed: "Error al registrar usuario",
    passwordsDoNotMatch: "Las contraseñas no coinciden",
    userHelloByTime: "!{timeOfDay} {name}!",
    preachingPageLabel: "Tu programación y asignaciones de predica",
    myPreachings: "Mis prédicas",
    preachingNextAssignment: "Tu próxima prédica",
    preachingNoAssignmentsNoMeeting: "Aún no se ha creado la reunión de planificación para este período.",
    preachingNoAssignmentsDidNotAttend:
      "No asististe a la reunión de planificación ni tienes una ausencia justificada.",
    preachingNoAssignmentsNotGeneratedYet:
      "Estás habilitado para recibir una prédica, pero el reparto todavía no se ha generado.",
    preachingConfirmAssignment: "Confirmar prédica",
    morning: "Día",
    afternoon: "Tarde",
    evening: "Noche",
    morningPrefix: "Buen día",
    afternoonPrefix: "Buenas tardes",
    eveningPrefix: "Buenas noches",
    nextPreachings: "Próximas predicas",
    noNextPreachings: "No hay eventos de predica próximos disponibles",
    preachingNoZonePreference:
      "Aun no tienes preferencia de zona para tus prédicas, Selecciona las zonas de tu preferencia para ser asignado en esas zonas",
    zonesMode: "Modo de zonas",
    groupsMode: "Modo de grupos",
    dateExceptionsRangeHelp: "Agrega rangos de fechas donde no estarás disponible para predicar.",
    startDate: "Inicio",
    endDate: "Fin",
    preachingFrequencyQuestion: "¿Cuántas veces estás dispuesto a predicar en un bimestre?",
    frequencyNoPreference: "No tengo preferencia (todas las que Dios me mande)",
    frequencyNone: "Ninguna",
    frequencyOnlyOne: "Solamente 1",
    editPreferences: "Editar preferencias",
    generatingReport: "Generando reporte",
    scriptureReference: "Cita bíblica",
    scriptureReferencePlaceholder: "Ej. Juan 3:16",
    liaisonView: "Vista de Enlace",
    liaisonViewDesc: "Gestiona las prédicas de tu grupo",
    noGroupsAssigned: "No tienes grupos asignados",
    noGroupsAssignedPermission:
      "No tienes grupos asignados. Solicita a un administrador que te asigne grupos desde el módulo de Seguridad.",
    newPlannedAssignment: "Nueva prédica planificada",
    preacherAlreadyAssigned: "ya tiene una prédica asignada en esta fecha.",
    chooseAnotherPreacher: "Elige otro predicador para continuar.",
    preacherAlreadyAssignedError: "Este predicador ya tiene una prédica asignada en esta fecha",
    preacherUnavailableTitle: "Predicador no disponible",
    preacherDateExceptionError: "Este predicador marcó esta fecha como no disponible.",
    upcomingEvents: "Próximas prédicas",
    sortOrder: "Orden de predicadores",
    sortAlphabetical: "Alfabéticamente",
    sortRandom: "Aleatorio",
    preachingZones: "Zonas de preferencia",
    dateExceptions: "Fechas no disponibles",
    assemblyDay: "Día de asamblea",
    selectOption: "Seleccionar...",
    daySunday: "Domingo",
    dayMonday: "Lunes",
    dayTuesday: "Martes",
    dayWednesday: "Miércoles",
    dayThursday: "Jueves",
    dayFriday: "Viernes",
    daySaturday: "Sábado",
    editEventDetails: "Detalles de la prédica",
    preachingTitlePlaceholder: "Nombre de la prédica",
    preachingStatusPending: "Pendiente",
    preachingStatusConfirmed: "Confirmada",
    preachingStatusRejected: "Rechazada",
    preachingStatusAssignedByLeader: "Asignado por el líder",
    assignedByLeader: "Asignado por el líder",
    myCalendar: "Mi Calendario",
    calendarToday: "Hoy",
    calendarWeekView: "Semana",
    calendarMonthView: "Mes",
    calendarMeeting: "Reunión",
    calendarNoEventsWeek: "Sin eventos esta semana",
    noServices: "No hay servicios",
    disposition: "Disponibilidad Bimensual",
    selectedZonesCount: "{count} zonas seleccionadas",
    previousPreachings: "Prédicas anteriores",
    loginPageLabel: "Inicia sesión para administrar retiros, predicas, y más",
    preachingNoZones: "No tienes zonas asignadas",
    preachingDashboardTab: "Dashboard",
    preachingDashboardTotalPreachers: "Total Predicadores",
    preachingDashboardTotalPreachersDesc: "Activos en el período",
    preachingDashboardTotalDates: "Total Fechas",
    preachingDashboardTotalDatesDesc: "En el rango seleccionado",
    preachingDashboardTotalGroups: "Grupos",
    preachingDashboardTotalGroupsDesc: "Con predicas asignadas",
    preachingDashboardTotalAttendance: "Total Asistencia",
    preachingDashboardTotalAttendanceDesc: "En el rango seleccionado",
    preachingDashboardAvgAttendance: "Asistencia Prom.",
    preachingDashboardAvgAttendanceDesc: "Promedio por predica",
    preachingDashboardByGroupDate: "Predicadores por Grupo / Fecha",
    preachingDashboardByPreacher: "Grupo / Fecha por Predicador",
    preachingDashboardUpcoming: "Próximas Predicas",
    preachingDashboardAttendanceTrend: "Tendencia de Asistencia",
    preachingDashboardAttendanceIndicators: "Indicadores de Asistencia",
    preachingDashboardExcellent: "Excelente",
    preachingDashboardGood: "Buena",
    preachingDashboardAverage: "Regular",
    preachingDashboardLow: "Baja",
    preachingDashboardPreachings: "predicas",
    preachingDashboardViewAll: "Ver todas las asignaciones",
    preachingDashboardViewAllPreachers: "Ver todos los predicadores",
    preachingDashboardViewFullSchedule: "Ver agenda completa",
    preachingAssignmentsConsole: "Consola de asignaciones",
    preachingAssignmentsConsoleDesc: "Consulta todas las asignaciones de prédica del período vigente.",
    preachingAssignmentsByGroup: "Por grupo",
    preachingAssignmentsByPreacher: "Por predicador",
    preachingAssignmentsDates: "{count} fechas",
    preachingAssignmentsGroups: "{count} grupos",
    preachingAssignmentsLocal: "{count} local",
    preachingAssignmentsOutsideZone: "{count} fuera de zona",
    preachingAssignmentsUnknownZone: "{count} sin zona definida",
    preachingAssignmentsNoMeeting:
      "No hay una reunión de planificación para el período vigente. Crea la reunión de planificación para ver las asignaciones.",
    preachingAssignmentsNoEvents:
      "El período vigente tiene una reunión de planificación, pero todavía no tiene asignaciones de prédica. Crea las asignaciones de la reunión para verlas aquí.",
    preachingNotifyPreachers: "Notificar a predicadores",
    preachingResendNotification: "Reenviar notificación",
    preachingNotifyNoMeeting: "No hay una reunión de planificación para el período vigente.",
    preachingNotifyNoAssignments: "No hay asignaciones de prédica para el período vigente.",
    preachingNotificationsSent: "Se notificó a {count} predicadores.",
    preachingNotificationsSkipped: "Se omitieron {count} por no tener correo.",
    preachingDashboardNoData: "Sin datos en el período seleccionado",
    preachingDashboardFilterPeriod: "Período",
    preachingDashboardAssign: "Asignar Predica",
    assignToFirstFloor: "Asignar cuarto del nivel uno (Casa De Jesús).",
    preachingDashboardOfMax: "del máx.",
    preachingAttendanceCount: "Cantidad de asistentes",
    preachingEventsFilterGroup: "Todos los grupos",
    preachingEventsFilterPreacher: "Todos los predicadores",
    preachingEventsFilterStatus: "Todos los estados",
    preachingEventsFilterFrom: "Desde",
    preachingEventsFilterTo: "Hasta",
    preachingEventsFilterReset: "Limpiar filtros",
    preachingEventsAttendance: "Asistencia",
    preachingEventsPageOf: "de",
    preachingEventsRowsPerPage: "por página",
    preachingEventsConfirmDelete: "¿Eliminar predica?",
    preachingEventsConfirmDeleteMessage: "Esta acción no se puede deshacer.",
    preachingEventsNoResults: "Ningún evento coincide con los filtros actuales.",
    login: "Iniciar sesión",
    homeLabelMessage:
      "Bienvenid@ a la plataforma de la Comunidad Católica El Salvador del Mundo: gestiona retiros, servicios y tu programación de prédicas en un solo lugar.",
    seeAll: "Ver todos",
    seeCalendar: "Ver calendario",
    notAttendedBadge: "No asistió",
    attendedBadge: "Asistió",
    absentPermission: "Permiso de ausentarse",
    absenceReason: "Motivo de la ausencia",
    goToCheckInPage: "Ir a la página",
    viewQR: "Ver QR",
    absentPermissionOf: "de",
    continueMarkingAttendance: "Continuar marcando asistencia",
    viewSummary: "Ver resumen",
    // Nickname
    nickname: "Conocido como",
    statusOptionActives: "Activos",
    statusOptionDeclined: "Inactivos",
    nicknamePlaceholder: "Cómo le llamamos",
    // Duplicate server alert
    serverAlreadyAssigned: "Ya está asignado a otro servicio",
    confirmAssignDuplicate: "Este servidor ya está asignado a otro servicio. ¿Asignar de todas formas?",
    servicesOrderWarning: "El orden de este listado es el utilizado para mostrar los servicios.",
    // Gender filter modal
    selectServerForService: "Seleccionar servidor para: {service}",
    editService: "Editar servicio",
    filters: "Filtros",
    clear: "Limpiar",
    apply: "Aplicar",
    attendedOnlyTooltip: "Filtrar para mostrar solo los servidores que asistieron",
    filterAttended: "Solo los que asistieron",
    filterAvailables: "Solo disponibles",
    filterNotAttended: "Solo los que no asistieron",
    notAttendedOnlyTooltip: "Filtrar para mostrar solo los servidores que no asistieron",
    noMeetingServiceDateSelected: "Ninguna fecha de servicio seleccionada",
    men: "Hombres",
    women: "Mujeres",
    // Export image
    exportImage: "Exportar Imagen",
    // Required servers
    requiredServers: "Servidores requeridos",
    requiredServersPlaceholder: "Número de servidores necesarios",
    // Confirmations
    confirmedAssignment: "Confirmado",
    unconfirmedAssignment: "Sin confirmar",
    confirmedCount: "{count} confirmados",
    addService: "Agregar servicio",
    serviceFormRequiredServers: "Servidores requeridos",
    serviceFormRequiredServersPlaceholder: "Número de servidores necesarios",
    serviceFormType: "Tipo de servicio",
    serviceFormTypePlaceholder: "Selecciona o escribe un nuevo tipo y presiona +",
    previewReport: "Vista previa",
    reportPreview: "Vista previa del reporte",
    options: "Ver opciones",
    paymentMethod: "Método de pago",
    paymentType: "Tipo de pago",
    deleteMeeting: "Eliminar reunión",
    editMeeting: "Editar reunión",
    markedAttendance: "Marcado como asistió",
    addManually: "Agregar manualmente",
    groupServersServicesTitle: "Servicios del servidor",
    groupServersServicesAddAll: "Agregar todos",
    groupServersServicesRemoveAll: "Remover todos",
    canToggleCancelled: "Cancelar reunion para no contar en la asistencia",
    isCancelled: "Cancelar reunion",
    addDate: "Agregar fecha",
    addNextDate: "Agregar próxima fecha",
    editDate: "Editar fecha",
    titleRequired: "El título es requerido",
    startDateRequired: "La fecha de inicio es requerida",
    startTimeRequired: "La hora de inicio es requerida",
    endTimeRequired: "La hora de fin es requerida",
    dayOfWeekRequired: "El día de la semana es requerido",
    repeatEveryInvalid: "La repetición es inválida",
    statusRequired: "El estado es requerido",
    dragToReorder: "Arrastrar para reordenar",
    requiredServersCount: "{count} personas requeridas",
    serversRequiredSuffix: "personas requeridas",
    attendanceDashboard: "Dashboard de Asistencia",
    attendanceTrend: "Tendencia de asistencia",
    topAttendance: "Mayor asistencia",
    bottomAttendance: "Menor asistencia",
    serviceCoverage: "Cobertura por servicio",
    attendanceByServer: "Asistencia por servidor",
    sortDescending: "Ordenar Descendente",
    sortAscending: "Ordenar Ascendente",
    totalServers: "Total de Servidores",
    attendanceRateTitle: "TASA DE ASISTENCIA",
    averageAttendanceTitle: "ASISTENCIA PROMEDIO",
    peoplePerMeeting: "personas por reunión",
    meetingsTitle: "REUNIONES",
    inThisPeriod: "en este período",
    activeServersTitle: "SERVIDORES ACTIVOS",
    activesOnly: "Solo los activos",
    inactivesOnly: "Solo los inactivos",
    photoPendingOnly: "Foto pendiente",
    uniqueServers: "servidores únicos",
    vsPreviousPeriod: "vs. período anterior",
    noChanges: "sin cambios",
    totalServersTitle: "TOTAL SERVIDORES",
    servingMarriedTitle: "MATRIMONIOS SIRVIENDO",
    singlesTitle: "SOLTEROS",
    sheepTitle: "OVEJAS",
    viewDetail: "Ver detalle",
    marriedTotal: "casados en total",
    spouseNotServing: "sin pareja sirviendo",
    inFreeUnion: "en unión libre",
    pastorsWithSheep: "pastores con ovejas",
    ageSegmentationTitle: "SEGMENTACIÓN POR EDAD",
    serverBirthdaysTitle: "CUMPLEAÑOS DE SERVIDORES",
    todaysBirthdays: "CUMPLEAÑOS DE HOY",
    noBirthdaysToday: "Ningún servidor cumple años hoy",
    serversCelebrateInMonth: "{count} servidores celebran en {month}",
    viewAllBirthdays: "Ver todos los cumpleaños",
    celebratingThisMonth: "celebran cumpleaños",
    noBirthdaysInMonth: "No hay cumpleaños registrados para este mes",
    turnsYears: "Cumple {age} años",
    todayBirthdayBadge: "¡Hoy!",
    serversOutsideConfiguredRanges: "servidores fuera de los rangos configurados",
    configure: "Configurar",
    configureAgeRanges: "Configurar Rangos de Edad",
    ageRangesDesc: "Define los rangos de edad para segmentar los servidores. Los rangos no deben solaparse.",
    fromAge: "Desde",
    toAge: "Hasta",
    addRange: "Agregar rango",
    reset: "Restablecer",
    valuesMustBePositive: "Los valores deben ser positivos",
    minMustBeLessThanMax: "Rango {index}: el mínimo debe ser menor que el máximo",
    rangesMustNotOverlap: "Los rangos no deben solaparse",
    bothServe: "Ambos sirven",
    onlyOneServes: "Solo uno sirve",
    totalAttendance: "Asistencia total",
    averageLabel: "promedio",
    totalAveragePerMeeting: "Total promedio por reunión",
    peopleLabel: "personas",
    marriedCouplesTitle: "Matrimonios",
    searchServerOrSpouse: "Buscar servidor o cónyuge...",
    noResultsFound: "No se encontraron resultados",
    printQR: "Imprimir QR",
    downloadQR: "Descargar QR",

    qrModalTitle: "Código QR de Asistencia",
    attendanceSystemSubtitle: "Sistema de Asistencia",
    communityTag: "Comunidad",
    scanToMarkAttendance: "ESCANEA PARA REGISTRAR ASISTENCIA",
    qrScanDescription: "Abre la cámara de tu teléfono para marcar tu asistencia automáticamente",
    meetingNotFoundTitle: "Reunión no encontrada",
    meetingNotFoundDesc:
      "El enlace o código QR parece ser inválido. Por favor solicita un nuevo código QR al encargado.",
    attendanceNotAvailableTitle: "Asistencia No Disponible",
    attendanceNotAvailableDesc: "La asistencia solo se puede registrar el día de la reunión en el horario configurado.",
    meetingScheduleLabel: "Horario de reunión:",
    allowedMarginNotice: "Margen permitido: 2 horas antes y después del horario de inicio.",
    step1Of2: "PASO 1 DE 2",
    selectYourNameTitle: "Selecciona tu nombre",
    selectYourNameDesc: "Busca tu nombre en la lista para recordar tu dispositivo durante las próximas 2 semanas.",
    searchPlaceholder: "Buscar nombre, telefono o correo",
    noNamesFound: "No se encontraron nombres.",
    registeredServer: "Servidor Registrado",
    changeUserButton: "Cambiar",
    changeUserTitle: "Cambiar persona",
    attendanceMarkedSuccessTitle: "¡Asistencia Registrada!",
    attendanceMarkedSuccessDesc: "Tu asistencia ha sido confirmada correctamente para el día de hoy.",
    pressButtonToMarkAttendance: "Presiona el botón a continuación para registrar tu asistencia:",
    markAttendanceButton: "MARCAR ASISTENCIA",
    attendanceMarkErrorDesc: "No se pudo registrar la asistencia. Inténtalo de nuevo.",
    serverAssignments: "Asignación de Servidores",
    serverAssignmentsDesc: "Consulta el ranking de servidores con más y menos asignaciones.",
    sortBy: "Ordenar por",
    serverAssignmentsRank: "Ranking de Asignación de Servidores",
    mostAssigned: "Más Asignados",
    leastAssigned: "Menos Asignados",
    servicesAssigned: "servicios asignados",
    viewDetails: "Ver detalles",
    totalServicesAssigned: "Total de servicios asignados",
    serviceType: "Tipo de servicios",
    noServicesAssigned: "Sin servicios asignados",
    backToList: "Volver a la lista",
    noData: "Sin datos",
    noHistoryFound: "No se encontró historial",
    allMeetings: "Todas las reuniones",
    serviceHistory: "Historial de servicios",
    managers: "Encargados",
    replacements: "Reemplazos",
    guestGridFilterUnder25: "Menores de 25",
    guestGridFilterAbove25: "Mayores a 24",
    guestGridFilterNotSingle: "No soltero/a",
    guestGridFilterSingle: "Soltero/a",
    workshopsCountInvalid: "El número de talleres no puede ser negativo",
    scrollToTop: "Volver arriba",
    ...commitmentTranslations.es
  }
};
